import React from "react";
import styled from "styled-components";
import { FlexBox, Text } from "@styles";
import { navigate } from "gatsby";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export interface PaginationProps {
  currentPage: number;
  numOfPages: number;
  isLast: boolean;
  isFirst: boolean;
  prefix: string;
  mode?: "static" | "client";
}

const CtaButton = styled.button`
  outline: none;
  border: none;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;

  :not(:disabled) {
    cursor: pointer;
  }
`;

const Pagination = ({ currentPage, isFirst, isLast, prefix, numOfPages, mode = "static" }: PaginationProps) => {
  // ensure we dont double the /
  const safePrefix = prefix.startsWith("/") ? prefix : `/${prefix}`;

  const hasQueryAlready = prefix.includes("?");
  const hasPageQuery = prefix.includes("page=");
  const querySymbol = hasQueryAlready ? "&" : "?";
  const stripPageQuery = hasPageQuery ? prefix.split("page=")[0] : `${safePrefix}${mode === "client" ? querySymbol : ""}`;

  const onPrev = () => {
    const pageNumber = mode === "client" ? `page=${currentPage - 1}` : `/${currentPage - 1}`;
    navigate(currentPage === 2 ? stripPageQuery : `${stripPageQuery}${pageNumber}`);
  };

  const onNext = () => {
    const pageNumber = mode === "client" ? `page=${currentPage + 1}` : `/${currentPage + 1}`;
    navigate(`${stripPageQuery}${pageNumber}`);
  };

  return (
    <FlexBox justifyContent="center" marginTop={3} alignItems="center" gap={1.5}>
      <CtaButton type="button" disabled={isFirst} onClick={onPrev} aria-label="Prev Page Button">
        <FaChevronLeft size={15} />
      </CtaButton>

      <Text size={1.05}>{`${currentPage} / ${numOfPages}`}</Text>

      <CtaButton type="button" disabled={isLast} onClick={onNext} aria-label="Next Page Button">
        <FaChevronRight size={15} />
      </CtaButton>
    </FlexBox>
  );
};
export default Pagination;
